module.exports = __webpack_public_path__ + "img/1.700895ad.png";